"use client";
import { FC } from "react";
import Grid from "@mui/material/Grid2";
import TopBar from "../topBar";
import { wrapperMain } from "./layout.style";
import Footer from "../footer";
import Toast from "../toast";

interface IProps {
  children: React.ReactNode;
}

const Layout: FC<IProps> = ({ children }) => {
  return (
    <Grid sx={wrapperMain}>
      <TopBar />
      <Grid>{children}</Grid>
      <Footer />
      <Toast />
    </Grid>
  );
};

export default Layout;
